module.exports = __webpack_public_path__ + "img/ywyk-instructions06.168472ac.jpg";